// import randomColor from "randomcolor"

// const colors = [];

// for (let i = 0; i < 50; i++) {
//     colors.push(
//         randomColor({
//             format: 'rgba',
//             luminosity: 'light',
//             hue: 'random',
//             alpha: 0.7
//         })
//     )
// }

// const colors = ["rgba(250, 208, 44, 0.30)", "rgba(230, 194, 191, 0.30)", "rgba(40, 33, 32,0.20)", "rgba(248, 239, 228, 0.40)"]

const colors = ["rgba(106, 117, 148,0.3)", "rgba(166, 50, 71, 0.3)", "rgba(63, 98, 116,0.4)", "rgba(89, 2, 2, 0.3)"]

export default colors;
